;(function ($, mat_theme) {
    "use strict";

    const FORM_SELECTOR = '#header_search_form';
    const INPUT_SELECTOR = '#header_search_input';
    const BUTTON_SELECTOR = '#header_search_area_toggle';

    const BREAKPOINT = mat_theme.main_menu_breakpoint;
    let menu_state_desktop_is_active = false;

    const addSetup_desktop = () => {

        if (menu_state_desktop_is_active) return;
        menu_state_desktop_is_active = true;


        $(BUTTON_SELECTOR).on('click', function (ev) {
            ev.preventDefault();
            toggle_desktop_search();
        });

        $(BUTTON_SELECTOR).on('keypress', function (ev) {
            ev.preventDefault();
            if (ev.which == 9) toggle_desktop_search();
        });

        $(FORM_SELECTOR).on('keyup', function (ev) {
            console.log('press ' + ev.which);
            if (ev.which == 27) toggle_desktop_search();
        });

    };

    const clearSetup_desktop = () => {
        if (!menu_state_desktop_is_active) return;
        menu_state_desktop_is_active = false;

        $(BUTTON_SELECTOR).off();
        $(FORM_SELECTOR).off();
        $(FORM_SELECTOR).removeClass('open');
        $(BUTTON_SELECTOR).removeClass('open');
    };

    const toggle_desktop_search = () => {

        $(FORM_SELECTOR).toggleClass('open');

        if ($(FORM_SELECTOR).hasClass('open')) {
            $(INPUT_SELECTOR).focus();
            $(BUTTON_SELECTOR).addClass('open');
        } else {
            $(BUTTON_SELECTOR).focus();
            $(BUTTON_SELECTOR).removeClass('open');
        }

    };

    const window_resize_action = () => {
        if (window.innerWidth >= BREAKPOINT) {
            // clearSetup_mobile();
            addSetup_desktop();
        } else {
            clearSetup_desktop();
            // addSetup_mobile();
        }
    };

    window_resize_action();
    window.addEventListener("resize", window_resize_action);

})(jQuery, mat_theme);